import { createSlice } from '@reduxjs/toolkit';

/**
 * Slice for the user.
 * This slice handles the user.
 */
export const initialState = {
    avatar: '',
    userName: '',
    email: '',
    authority: [],
    sub: '',
};

export const userSlice = createSlice({
    name: 'auth/user',
    initialState,
    reducers: {
        setUser: (_, action) => action.payload,
        userLoggedOut: () => initialState,
    },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
